import { Designer } from './Designer.js';
import { autofillSurface } from '../autoFill/index.js';
import type { IPhoto, IProject, ISurface } from '../common/index.js';
import { isUserPhotoAsset } from '../common/utils/index.js';

export class MultiSurfaceDesigner extends Designer {

    public designProject(): IProject {
        const remainingPhotos = new Set(this.photos);
        const usedPhotos = new Set<IPhoto>();
        const photoMap = new Map(this.photos.map((photo) => [photo.photoId, photo]));
        const filledSurfaces: ISurface[] = [];

        for (const surface of this.project.surfaces) {
            const updatedSurface = autofillSurface(surface, [...remainingPhotos], this.cropStrategy);

            filledSurfaces.push(updatedSurface);

            for (const asset of updatedSurface.assets) {
                if (isUserPhotoAsset(asset) && asset.content?.photoId) {
                    const photo = photoMap.get(asset.content.photoId);

                    if (photo && remainingPhotos.has(photo)) {
                        remainingPhotos.delete(photo);
                        usedPhotos.add(photo);
                    }
                }
            }
        }

        return {
            ...this.project,
            photos: [...usedPhotos],
            surfaces: filledSurfaces,
        };
    }

}
